import { ChangeDetectionStrategy, Component, inject, OnInit, TemplateRef, viewChild } from '@angular/core';
import { take } from 'rxjs';
import { AuthService } from '../../core/services/auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OverlayService } from '../../core/services/overlay.service';
import { DecoratorOverlayService } from '../../core/utils/loader-decorator';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lbt-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  standalone: false
})
export class MainLayoutComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly matDialog = inject(MatDialog);

  protected readonly overlayService = inject(OverlayService);
  protected readonly decoratorOverlayService = inject(DecoratorOverlayService);

  private expireDialog: MatDialogRef<any> | null = null;

  sessionExpiredTmpl = viewChild.required<TemplateRef<any>>('sessionExpiredTmpl');

  ngOnInit() {
    this.authService.expiredRefreshToken$
      .pipe(take(1))
      .subscribe(() => this.openSessionExpired());
  }

  openSessionExpired() {
    if (this.expireDialog) {
      return;
    }
    this.authService.isSessionExpired = true;
    this.expireDialog = this.matDialog.open(this.sessionExpiredTmpl(),  {
      disableClose: true
    });

    this.expireDialog
      .afterClosed()
      .subscribe(() => {
        this.authService.logOut();
        this.expireDialog = null;
      });
  }
}
